import { createSelector } from "@reduxjs/toolkit";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectViewStates } from "views/logic/slices/viewSelectors";
const selectWidgetIdsByQuery = createSelector(
  selectViewStates,
  (viewState) => viewState.map((state) => state.widgets.map((widget) => widget.id).toList()).toMap()
);
const useWidgetIds = () => useViewsSelector(selectWidgetIdsByQuery);
export default useWidgetIds;
